import { authrequest, gustrequest, multipart, request } from "./../config/request" 
import qs from 'qs';
export const getTypeOfCourts = (params={}) => {
     
        params = qs.stringify(params, {
                encodeValuesOnly: true, // prettify URL
              });
              
        return request.get(`/api/type-of-courts?${params}`).then(res => res?.data);
}